// extracted by mini-css-extract-plugin
export default {"tooltip":"tooltip---cm23J","fadeInOpacity":"fadeInOpacity---IlbHV","text":"text---irzOm","sub":"sub---VfEG4"};